export default __webpack_public_path__ + "static/media/_comment-icon_dark.b62978f3.svg";